import type { IEquityMovement } from '@modeso/types__aumico-lib-annualreport-be';

export interface IEmsPeriodColumn {
    id: string;
    type: 'SYSTEM' | 'USERDEFINED' | 'TOTAL';
    title: string;
    opening: number | null;
    closingTarget: number | null;
    openingEditable: boolean;
    sumUpTotalColIDs?: string[];
    movements: IEquityMovement[];
}

export interface IEmsPeriodChange {
    openingTitle: string;
    closingTitle: string;
    columns: { id: string; opening: number | null; movements: IEquityMovement[] }[];
}
